import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch } from '@patternfly/react-core';

import { selectCustomizationBaseById, selectCustomizationOutputById, selectModelById, selectRoiCustomizationById } from '../../store/selectors';
import { StoreState, updateRoiCustomizationIncludedInModel } from '../../store/reducers';
import CustomizationLabel from '../../components/customization-label';
import { Td, Tr } from '@patternfly/react-table';
import { columnIds } from '../customization/RoiTable';
import { useTranslation } from 'react-i18next';

interface CoveredRoiProps {
    coveredRoiId: string;
}


const CoveredRoi = (props: CoveredRoiProps) => {
    const { coveredRoiId } = props;

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const roi = useSelector((state: StoreState) => selectRoiCustomizationById(state, coveredRoiId));
    const customizationOutput = useSelector((state: StoreState) => roi && roi.modelCustomizationOutputId ? selectCustomizationOutputById(state, roi.modelCustomizationOutputId) : undefined);
    const customizationBase = useSelector((state: StoreState) => customizationOutput && selectCustomizationBaseById(state, customizationOutput.modelCustomizationBaseId));
    const segmentationModel = useSelector((state: StoreState) => customizationBase && selectModelById(state, customizationBase.segmentationModelId));

    const handleIncludedChange = useCallback((isIncluded: boolean) => {
        dispatch(updateRoiCustomizationIncludedInModel(coveredRoiId, isIncluded, false));
    }, [dispatch, coveredRoiId]);

    if (!roi || !customizationOutput || !customizationBase || !segmentationModel) {
        if (!roi) { console.log(`no roi: ${coveredRoiId}`) }
        else if (!customizationOutput) console.log(`no customization output: ${roi.modelCustomizationOutputId}`)
        else if (!customizationBase) console.log(`no customization: ${customizationOutput.modelCustomizationBaseId}`)
        else if (!segmentationModel) console.log(`no segmentation model: ${customizationBase.segmentationModelId}`)
        return null;
    }

    return (
        <Tr key={coveredRoiId}>
            <Td dataLabel={columnIds.customization}>
                <CustomizationLabel friendlyName={segmentationModel.label} modelName={segmentationModel.modelName} customizationName={customizationBase.customizationName} />
            </Td>

            <Td dataLabel={columnIds.targetFile}>
                {t('customizationPage.targetFile')}: <span className="target-file">{customizationOutput.filename}</span>
            </Td>

            <Td dataLabel={columnIds.isIncluded}>
                <Switch
                    id={`covered-roi-included-input-${roi.id}`}
                    isChecked={roi.isIncluded}
                    onChange={handleIncludedChange}
                    label={t('toggle.roiIncludedInStructureSet.on')}
                    labelOff={t('toggle.roiIncludedInStructureSet.off')}
                />
            </Td>

        </Tr>
    );
}

export default CoveredRoi;
